export interface ICustomerTagsProps {
  isBanned?: boolean
  bannedAt?: string
  isFlagged?: boolean
}

export default function CustomerTags({ isBanned, bannedAt, isFlagged } : ICustomerTagsProps) {
  return (
    <div className='session-tags__container flex flex-wrap'>
      {isBanned && <div className='session-tags__tag'><div className='flex items-center gap-1'><tgdb-ica-icon-info style={{ fontSize: '12px' }} />Spärrad{bannedAt && <>: {bannedAt}</>}</div></div>}
      {isFlagged && <div className='session-tags__tag'><div className='flex items-center gap-1'><tgdb-ica-icon-info style={{ fontSize: '12px' }} />Flaggad kund</div></div>}
    </div>
  )
}
